import useWindowSize from '../../../utils/useWindowSize';
import DesktopTimePicker from './Desktop';
import MobileTimePicker from './Mobile';

const CustomTimePicker = (props) => {
  const { isMobile } = useWindowSize();
  return isMobile ? <MobileTimePicker {...props} /> : <DesktopTimePicker {...props} />;
};

export default CustomTimePicker;
